<h2>Valores fiscais</h2>
<div class="tax-price">
  <p-table
    *ngIf="subscriptionAndSubscriptionTypes?.length"
    [value]="subscriptionTypesTableData"
    styleClass="custom-table"
    [scrollable]="false"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pFrozenColumn>Valores das assinaturas</th>
        <th
          colspan="2"
          *ngFor="let sub of subscriptions"
          [ngClass]="headerClass(sub)"
          class="tax-price__two-columns"
        >
          {{ sub.subscriptionName | titlecase }}
          <ng-container *ngIf="premium(sub)"
            >&nbsp;<i
              class="pi pi-crown"
              style="color: gold; font-weight: 700; font-size: 18px"
            ></i
          ></ng-container>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row let-index="rowIndex">
      <tr>
        <td pFrozenColumn>{{ row.label }}</td>
        <td colspan="2" *ngFor="let sub of subscriptionAndSubscriptionTypes">
          <ng-container *ngIf="sub.subscriptionTypes?.at(index)">
            R$ {{ getSubscriptionTypePrice(sub, row.label) }}
          </ng-container>
          <ng-container *ngIf="!sub.subscriptionTypes?.at(index)"
            >N/D</ng-container
          >
        </td>
      </tr>
    </ng-template>
  </p-table>
  <br />
  <p-table
    *ngIf="subscriptions?.length"
    [value]="tableData"
    class="custom-table"
    [tableStyle]="{ 'min-width': '880px' }"
    [scrollable]="true"
    dataKey="value"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pFrozenColumn>Valor do e-book</th>
        <th
          *ngFor="let sub of subscriptions"
          colspan="2"
          [ngClass]="headerClass(sub)"
        >
          {{ sub.subscriptionName | titlecase }}
          <ng-container *ngIf="premium(sub)"
            >&nbsp;<i
              class="pi pi-crown"
              style="color: gold; font-weight: 700; font-size: 20px"
            ></i
          ></ng-container>
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row let-index="rowIndex">
      <tr>
        <td pFrozenColumn>{{ row.label }}</td>
        <ng-container *ngFor="let sub of subscriptions">
          <td>
            <span *ngIf="sub.ebookPrices?.at(index)">
              {{ sub.ebookPrices?.at(index)?.price | currency: 'BRL' }}
            </span>
            <ng-container *ngIf="!sub.ebookPrices?.at(index)">N/D</ng-container>
          </td>
          <td *ngIf="sub.ebookPrices?.at(index)?.price > 0">
            {{
              getPercentageValue(sub.ebookPrices.at(index)) | number: '1.0-2'
            }}%
          </td>
          <td
            *ngIf="
              !sub.ebookPrices?.at(index)?.price ||
              sub.ebookPrices?.at(index)?.price <= 0
            "
          ></td>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>
  <br />
  <p-table
    *ngIf="subscriptions?.length"
    [value]="tableData"
    class="custom-table"
    [tableStyle]="{ 'min-width': '880px' }"
    [scrollable]="true"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pFrozenColumn>Valor do serviço</th>
        <th
          *ngFor="let sub of subscriptions"
          colspan="2"
          [ngClass]="headerClass(sub)"
        >
          {{ sub.subscriptionName | titlecase }}
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row let-index="rowIndex">
      <tr>
        <td pFrozenColumn>{{ row.label }}</td>
        <ng-container *ngFor="let sub of subscriptions">
          <td>
            <span *ngIf="sub.servicePrices?.at(index)">
              {{ sub.servicePrices?.at(index)?.price | currency: 'BRL' }}
            </span>
            <ng-container *ngIf="!sub.servicePrices?.at(index)">
              N/D
            </ng-container>
          </td>
          <td *ngIf="sub.servicePrices?.at(index)?.price > 0">
            {{
              getPercentageValue(sub.servicePrices.at(index)) | number: '1.0-2'
            }}%
          </td>
          <td
            *ngIf="
              !sub.servicePrices?.at(index)?.price ||
              sub.servicePrices?.at(index)?.price <= 0
            "
          ></td>
        </ng-container>
      </tr>
    </ng-template>
  </p-table>
</div>
